import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ColorSelector } from '@yme/atoms/color-selector';
import { getProductCardLabels } from '@yme/pdp-components/ProductCard';
import { getRTL } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
export function SelectColor({ isAccessory, colorVariants, colorItemIndex, onChangeColor: onChangeColorHandler, }) {
    const [colorLabel, setColorLabel] = useState('');
    const isRightToLeft = useSelector(getRTL);
    const productCardLabels = useSelector(getProductCardLabels);
    const colorVariantsCount = colorVariants?.length;
    const isColorsOptionExist = colorVariantsCount > 0;
    const onChangeColor = useCallback((index, colourId) => {
        onChangeColorHandler(index, colourId);
    }, [onChangeColorHandler]);
    useEffect(() => {
        const currentColorLabel = colorVariants[colorItemIndex]?.colourName;
        if (colorLabel !== currentColorLabel) {
            setColorLabel(currentColorLabel);
        }
    }, [colorItemIndex, colorLabel, colorVariants]);
    if (isAccessory && colorVariantsCount === 1) {
        return null;
    }
    if (isColorsOptionExist) {
        return (React.createElement(FlexWrapper, { flexDirection: "column", mt: "24px", mb: "24px" },
            React.createElement(FlexWrapper, { flexDirection: "row", gap: "4px", flexWrap: "wrap", mb: "8px" },
                React.createElement(RegularTextLevel3, { weight: 500 }, `${productCardLabels?.productCard_colorSelector_label}:`),
                React.createElement(RegularTextLevel3, { color: colorCoreBlack300, weight: 500 }, colorLabel)),
            React.createElement(ColorSelector, { data: colorVariants, activeItemColorIndex: colorItemIndex, onClick: onChangeColor, isRightToLeft: isRightToLeft })));
    }
    return null;
}
SelectColor.displayName = 'SelectColor_Component';
